import React, { useContext } from 'react';
import { LanguageContext } from '../components/LanguageContext';
import pressNotePdf from '../data/Urdu Press Note 2026.pdf';

const Celebrating50Years = () => {
  const { language } = useContext(LanguageContext);

  return (
    <div className={`min-h-screen bg-gray-50 py-8 px-4 ${language === 'ur' ? 'rtl' : 'ltr'}`}>
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-6">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
            {language === 'en' ? 'Urdu Academy Press Note 2026' : 'اردو اکادمی پریس نوٹ 2026'}
          </h1>
          <a
            href={pressNotePdf}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-blue-800 hover:bg-blue-900 text-white px-5 py-2.5 rounded-md font-medium shadow transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            {language === 'en' ? 'Open / Download PDF' : 'پی ڈی ایف کھولیں / ڈاؤن لوڈ کریں'}
          </a>
        </div>
        <div className="bg-white rounded-lg shadow border border-gray-200 overflow-hidden" style={{ minHeight: '80vh' }}>
          <iframe
            src={`${pressNotePdf}#toolbar=1`}
            title={language === 'en' ? 'Urdu Academy Press Note 2026' : 'اردو اکادمی پریس نوٹ 2026'}
            className="w-full h-full min-h-[80vh] border-0"
          />
        </div>
      </div>
    </div>
  );
};

export default Celebrating50Years;

